import { Component, OnInit, AfterViewInit, Inject, ViewChild, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { SelectionModel } from '@angular/cdk/collections';



import { IZipCode, ZipCodeApiService, IContractorServiceZip } from '@ebb-v2/ebb-integration';
import { forEach } from 'lodash';
import { IfStmt } from '@angular/compiler';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'ebb-portal-deletedialog-zipcode',
  templateUrl: './dialog-deletezipcode.component.html'
})
export class DialogDeleteZipcodeComponent implements OnInit, AfterViewInit {
  public title = 'REMOVE SERVICE ZIP CODES';

  public listZip: IZipCode[] = [];
  public listZipSelected: IZipCode[] = [];
  public listSearch: IZipCode[] = [];

  public dataSourceTable = new MatTableDataSource<IZipCode>([]);
  public selection = new SelectionModel<IZipCode>(true, []);
  public dataResultsLength = 0;
  displayedColumns: string[] = ['select',  'name',  'city','county',];
  public tablePageSizeOptions: number[] = [5, 10, 25];


  public formSearch: FormGroup;

  public waitForListingToShow = true;
  public noSearchResults = false;
  public removeButtonDisabled = true; 
  @ViewChild(MatPaginator) dataPaginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  constructor(
    public readonly dialogDeleteRef: MatDialogRef<DialogDeleteZipcodeComponent>,
    public readonly apiZipCode: ZipCodeApiService,
    @Inject(MAT_DIALOG_DATA) public data: IContractorServiceZip[],
    private readonly fb: FormBuilder,
    private readonly cdRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.dataSourceTable.paginator = this.dataPaginator;
    this.InitializeForms();
    this.loadData();
    this.updateRemoveButtonState();
    
  }

  ngAfterViewInit() {
    this.dataSourceTable.paginator = this.dataPaginator;
    this.dataSourceTable.sort = this.sort;
    //this.listZipSelected = null;
  }
  onKeyPress(event: KeyboardEvent): void {
    const allowedChars = /[a-zA-Z0-9 ]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (!allowedChars.test(inputChar) && event.key !== 'Backspace' && event.key !== 'Delete') {
      event.preventDefault();
    }
  }

  private InitializeForms(): void {
    // Permit info
    this.formSearch = this.fb.group({
      searchPhrase: ['', [Validators.pattern('^[a-zA-Z0-9 ]*$')]]
    });

   }
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSourceTable.data.length;
    this.updateRemoveButtonState();
    return numSelected === numRows;
   
  }

  /** Selects all rows if they are not all selected; otherwise clears selection. */
  masterToggle() {
    this.isAllSelected() ?
        this.selection.clear() :
        this.dataSourceTable.data.forEach(row => this.selection.select(row));
        this.updateRemoveButtonState();
  }
  updateRemoveButtonState() {
    this.removeButtonDisabled = this.selection.isEmpty(); // selection is the MatSelectionModel
  }
  private loadData(): void {
   // tslint:disable-next-line:prefer-const

    this.apiZipCode
    .get()
    .subscribe(
      data => {
        let deletezipcodes: IZipCode[] = [];
        this.data.forEach(function (value) {
          const zipcodefound = data.filter(x=>x.name === value.name);
          if (zipcodefound.length>0){

             let deletezipcode: IZipCode = {} as IZipCode;
            deletezipcode = zipcodefound[0];
            if (deletezipcodes.length ===0 || undefined){
              deletezipcodes = zipcodefound;
            }else{
            deletezipcodes.push(deletezipcode);}

          }

        });
        this.listZip = deletezipcodes;
        this.pageDirectoryData(this.listZip);
      },
      error => console.warn(`${JSON.stringify(error)}`),
    );
  }

  private pageDirectoryData(paginateList: IZipCode[]): void {
    if ( Array.isArray(paginateList) && paginateList.length > 0 )
    {
      this.noSearchResults = false;
      this.dataResultsLength = paginateList.length;
      this.dataSourceTable.data = paginateList;
    }
    else {
      this.noSearchResults = true;
    }
    this.cdRef.markForCheck();
    this.waitForListingToShow = false;
  }

  public checkboxLabel(row?: IZipCode): string {
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.name}`;
  }

  public searchZipCodeListByPhrase(phrase: string): void {
    phrase = phrase.trim().toLowerCase();
    this.listSearch = this.listZip.filter((code: IZipCode) => {
      const nameMatch = code.name && code.name.toLowerCase().includes(phrase);
      const cityMatch = code.city && code.city.toLowerCase().includes(phrase);
      const countyMatch = code.county && code.county.toLowerCase().includes(phrase);
      
      return nameMatch || cityMatch || countyMatch;
    });
  
    this.dataSourceTable.data = this.listSearch;
    this.cdRef.markForCheck();
  }


  onClickCancel(): void {
    this.dialogDeleteRef.close();
  }

  onClickSave(): void {
    for(let i = 0;  i < this.dataSourceTable.data.length; i++) {
      if (this.selection.isSelected(this.dataSourceTable.data[i])) {
        this.listZipSelected.push(this.dataSourceTable.data[i]);
      }
    }
    this.dialogDeleteRef.close(this.listZipSelected);
  }

}
